/* Consolidated product page scripts */

(() => {
  const section = document.getElementById("weightTestimonials");
  if (!section) return;

  const track = section.querySelector(".weight-testimonials__track");
  const cards = [...section.querySelectorAll(".weight-card")];
  const dots = [...section.querySelectorAll(".weight-testimonials__dot")];
  let current = 0;
  let startX = 0;
  let endX = 0;
  let wasMobile = window.innerWidth < 768;

  const isMobile = () => window.innerWidth < 768;

  const update = (index) => {
    current = Math.max(0, Math.min(index, cards.length - 1));
    track.style.transform = isMobile()
      ? `translateX(${-current * 100}%)`
      : "none";

    dots.forEach((dot, i) => {
      dot.classList.toggle("is-active", i === current);
      dot.setAttribute("aria-current", i === current ? "true" : "false");
    });
  };

  const move = (direction) => {
    const last = cards.length - 1;
    update(direction === "next"
      ? (current === last ? 0 : current + 1)
      : (current === 0 ? last : current - 1));
  };

  section.addEventListener("click", (event) => {
    const dot = event.target.closest(".weight-testimonials__dot");
    if (dot) {
      update(Number(dot.dataset.slide));
      return;
    }

    const arrow = event.target.closest(".weight-testimonials__arrow");
    if (arrow) move(arrow.dataset.direction);
  });

  track.addEventListener(
    "touchstart",
    (event) => {
      startX = endX = event.touches[0].clientX;
    },
    { passive: true }
  );

  track.addEventListener(
    "touchmove",
    (event) => {
      endX = event.touches[0].clientX;
    },
    { passive: true }
  );

  track.addEventListener("touchend", () => {
    if (isMobile() && Math.abs(startX - endX) > 40) {
      move(startX > endX ? "next" : "prev");
    }
    startX = endX = 0;
  });

  window.addEventListener("resize", () => {
    const mobile = isMobile();
    if (mobile !== wasMobile) {
      wasMobile = mobile;
      update(current);
    }
  });

  update(0);
})();

(() => {
  const faq = document.querySelector(".sv-faq-section");
  if (!faq) return;

  faq.addEventListener("click", (event) => {
    const button = event.target.closest(".sv-faq-question");
    if (!button || !faq.contains(button)) return;

    const item = button.closest(".sv-faq-item");
    const answer = item.querySelector(".sv-faq-answer");
    const isOpen = item.classList.toggle("active");

    button.setAttribute("aria-expanded", String(isOpen));
    answer.hidden = !isOpen;
  });
})();